module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAUCAYAAAC58NwRAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAACXSURBVCiRldPBEYMgEIXhf6UcD5agVXCkFCQpxWOq0BI8WE9yiUyIAss7wfC+2QsLgHU+WOcDihjrfECYEaZ+GOXYt7UEuuQmzLVJ5ti3tR9GQZi+qDjJALQgcx60yPxeNCgBGnQBNXQLSqjLgVwk9xB/wJk3j9fyDLcgV76dUCpfQK2cAE05Am0ZQFrK8L8PlXJMy4p+AA8/chcZAyBpAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./images/baseintrov2/to.png
// module id = 595
// module chunks = 0